import { ref, onMounted, onBeforeUnmount, nextTick, watch } from "vue";
import { throttle } from "./utils/throttle";

export const useContainerQuery = (containerElement, breakpoint = "xl", throttleDelay = 16) => {
  const breakpoints = {
    xs: 375,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400,
  };

  const breakpointValue = breakpoints[breakpoint];
  if (!breakpointValue) {
    console.warn(`Breakpoint '${breakpoint}' not found. Available: ${Object.keys(breakpoints).join(', ')}`);
    return { isBelowBreakpoint: ref(false) };
  }

  // 초기값: breakpoint보다 크다고 가정 (SSR 대응)
  const isBelowBreakpoint = ref(false);
  let resizeObserver = null;

  const update = () => {
    if (containerElement.value) {
      const width = containerElement.value.offsetWidth;
      isBelowBreakpoint.value = width <= breakpointValue;
    }
  };

  // throttle 적용 (기본 16ms - 한 프레임)
  const throttledUpdate = throttle(update, throttleDelay);

  // containerElement가 설정되면 초기화
  watch(
    () => containerElement.value,
    (newValue) => {
      if (newValue && typeof window !== "undefined") {
        // 즉시 업데이트
        update();
        
        // ResizeObserver를 사용하여 컨테이너 크기 변화 감지
        if (resizeObserver) {
          resizeObserver.disconnect();
        }
        
        resizeObserver = new ResizeObserver(() => {
          throttledUpdate();
        });
        
        resizeObserver.observe(newValue);
      }
    },
    { immediate: true }
  );

  onMounted(async () => {
    await nextTick();
    if (typeof window !== "undefined" && containerElement.value) {
      // 즉시 업데이트
      update();
      
      // watch에서 이미 observer가 설정되었을 수 있으므로 확인
      if (!resizeObserver) {
        resizeObserver = new ResizeObserver(() => {
          throttledUpdate();
        });
        resizeObserver.observe(containerElement.value);
      }
    }
  });

  onBeforeUnmount(() => {
    if (resizeObserver) {
      resizeObserver.disconnect();
      resizeObserver = null;
    }
  });

  return { isBelowBreakpoint };
};

